/*
    Imports the Roast API URL from the config.
*/
import { API_CONFIG } from './aru.env';
import axios from 'axios';
const Qs = require('qs');
export default {
  getBaseUrl: function() {
    return API_CONFIG.API_URL;
  },

  getHeaders: function() {
    let token = localStorage.getItem('token');
    let headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    };

    if (token) {
      headers['Authorization'] = token;
    }
    return headers;
  },

  get: function(url, config = {}) {
    if (!config.hasOwnProperty('headers')) {
      config.headers = this.getHeaders();
    }

    config.paramsSerializer = function(params) {
      const res = Qs.stringify(params, {
        encode: false,
      });
      console.log(res);
      return res;
    };
    return axios.get(API_CONFIG.API_URL + url, config);
  },

  delete: function(url, config = {}) {
    if (!config.hasOwnProperty('headers')) {
      config.headers = this.getHeaders();
    }

    return axios.delete(API_CONFIG.API_URL + url, config);
  },

  post: function(url, data, config = {}) {
    if (!config.hasOwnProperty('headers')) {
      config.headers = this.getHeaders();
    }
    return axios.post(API_CONFIG.API_URL + url, data, config);
  },

  put: function(url, data, config = {}) {
    if (!config.hasOwnProperty('headers')) {
      config.headers = this.getHeaders();
    }
    return axios.put(API_CONFIG.API_URL + url, data, config);
  },

  downloadBlob: function(url, config = {}) {
    if (!config.hasOwnProperty('params')) {
      config.params = {};
    }

    if (!config.params.hasOwnProperty('name')) {
      config.params.name = 'file';
    }

    if (!config.hasOwnProperty('responseType')) {
      config.responseType = 'blob';
    }

    if (!config.params.hasOwnProperty('extension')) {
      config.params.extension = 'zip';
    }

    config.paramsSerializer = function(params) {
      const res = Qs.stringify(params, {
        encode: false,
      });
      return res;
    };

    return axios.get(API_CONFIG.API_URL + url, config).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', config.params.name + '.' + config.params.extension);
      document.body.appendChild(link);
      link.click();
    });
  },

  downloadFile: function(filePath, config = {}) {
    window.open(filePath, '_blank');
    // window.location.href = filePath;
  },
  postUpload: function(url, data, config = {}) {
    if (!config.hasOwnProperty('headers')) {
      config.headers = this.getHeaders({
        upload: true,
      });
    }
    return axios.post(API_CONFIG.API_URL + url, data, config);
  },
};
